/**
 * Created by Administrator on 2020/12/16.
 */
// Created by hejikun on 2017/10/25 0025.
let state = {
  sender: {}, // 寄件人
  recipients: {}, // 收件人
  flowersOrder: {}
}

const actions = {}

const getters = {}

const mutations = {
  // 设置部门列表
  set_flowers_user(state, args) {
    switch (args.type) {
      case 'recipients':
        state.recipients = args.data
        break
      case 'sender':
        state.sender = args.data
        break
      default:
        break
    }
  },
  set_flowers_order(state, args) {
    state.flowersOrder = args.data
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
